import { urlConfig } from "../../config/urlConfig";
import { postCall, postFileDownloadCall } from "../httpService";

const GetArchivalReport = urlConfig.GetArchivalReport;
const GetDownload = urlConfig.GetDownload;
const QueueManagementFileInformation = urlConfig.QueueManagementFileInformation;
const DocumentViewerUrl = urlConfig.documentViewer;

export const getArchivalReportsData = async (params: any) => {
  try {
    const response = await postCall(GetArchivalReport, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getDownloadedData = async (downloadFilePayLoad: any) => {
  try {
    const response = await postFileDownloadCall(GetDownload, downloadFilePayLoad);
    return response;
  } catch (error) {
    console.error("Error fetching downloaded data", error);
    throw error;
  }
};

export const fileInformation = async (params: any) => {
  try {
    const response = await postCall(QueueManagementFileInformation, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getDocumentDetails = async (params: any) => {
  try {
    const response = await postCall(DocumentViewerUrl, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching DocumentDetails", error);
    throw error;
  }
};

export const saveArchivalReport = async (params: any) => {
  try {
    const response = await postCall(urlConfig.SaveArchivalReport, params);
    return response.data;
  } catch (error) {
    console.error("Error saving archival report", error);
    throw error;
  }
};
